import {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-hot-toast';
import {SERVER_URL} from "../../config";
import {authHeaders} from "../../utils/api";

const generateCode = () => {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
};

export function useAutoCreateRoom({
                                      userId,
                                      selectedLanguage,
                                      enabled = true,
                                  }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const hasRunRef = useRef(false);

    useEffect(() => {
        if (!enabled) return;
        if (hasRunRef.current) return;

        hasRunRef.current = true;

        const createRoom = async () => {
            if (!userId) {
                toast.error('User ID not found. Please login again.');
                navigate('/');
                return;
            }

            const code = generateCode();
            setLoading(true);

            try {
                const res = await fetch(
                    `${SERVER_URL}/api/rooms`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...authHeaders(),
                        },
                        body: JSON.stringify({
                            code,
                            lang_code: selectedLanguage,
                        }),
                    }
                );

                if (!res.ok) {
                    const error = await res.json();
                    throw new Error(error.detail || 'Failed to create room');
                }

                toast.success(`Lab room ${code} ready 🎙️`);
                navigate(`/voice-lab/${code}`);
            } catch (err) {
                console.error('Auto room creation failed:', err);
                toast.error('Failed to start lab. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        createRoom();
    }, [userId, selectedLanguage, enabled, navigate]);

    return {loading};
}
